import { useEffect, useState } from "react"
import { simpleGetter } from "../actions/common"
import { newUniversalApi, universalApi } from "../api/api"

const useBoard = (id) => {
    const [data, setData] = useState({})

    const fetchData = async () => {
        const reqBody = {
            model: 'Board',
            body: {
                filters: {
                    id
                }
            }
        }
        const response = await simpleGetter(universalApi.find, reqBody)
        console.log(response)
        if (response.list?.length) {
            setData(response.list[0])
        }
    }

    useEffect(() => {
        fetchData()
    }, [id])

    return data
}

const useBoards = (triggerFetch) => {
    const [data, setData] = useState([])

    const fetchData = async () => {
        const reqBody = {
            model: 'Board',
            body: {
                user_params: {
                    user_key: 'main_user_id'
                }
            }
        }
        const response = await simpleGetter(newUniversalApi.find, reqBody)
        console.log(response)
        if (response.list?.length) {
            setData(response.list)
        }
    }

    useEffect(() => {
        fetchData()
    }, [triggerFetch])

    return data
}

const useBoardTasks = (id, trigger) => {
    const [data, setData] = useState([])

    const fetchData = async () => {
        const reqBody = {
            model: 'BoardTask',
            body: {
                filters: {
                    board_id: id
                },
                params: {
                    include: ['likes', 'author']
                }
            }
        }
        const response = await simpleGetter(universalApi.find, reqBody)
        if ('list' in response) {
            setData(response.list)
        }
    }

    useEffect(() => {
        fetchData()
    }, [id, trigger])

    return data
}

export {
    useBoard,
    useBoardTasks,
    useBoards
}